import {
  BannerNotificationItem,
  SessionItem,
  SubscriptionItem,
  UsageItem,
} from '../../types/responses/users'
import { apiService } from './apiService'

class UserService {
  private endpoint = '/user'

  async getSession(): Promise<SessionItem | null> {
    const response = await apiService.get(`${this.endpoint}/session`)

    return response.data
  }

  async getSubscription(): Promise<SubscriptionItem | null> {
    const response = await apiService.get(`${this.endpoint}/subscription`)

    return response.data?.subscription || null
  }

  async cancelCurrentSubscription() {
    const response = await apiService.delete(`${this.endpoint}/subscription`)

    return response.data
  }

  async cancelCurrentSubscriptionImmediately() {
    const response = await apiService.delete(
      `${this.endpoint}/subscription?cancelImmediately=true`,
    )

    return response.data
  }

  async getUsage(): Promise<UsageItem> {
    const response = await apiService.get(`${this.endpoint}/usage`)

    return response.data
  }

  async getBannerNotification(): Promise<BannerNotificationItem | null> {
    const response = await apiService.get(
      `${this.endpoint}/banner-notification`,
    )

    return response.data
  }
}

const userService = new UserService()

export default userService
